// extracted by mini-css-extract-plugin
module.exports = {"iPopup":"VideoPopup_iPopup__NbFHo","videoContainer":"VideoPopup_videoContainer__W_ieX","close":"VideoPopup_close__0nEVu"};